import VideoSettings from './VideoSettings'

export default VideoSettings
